import { format, startOfMonth, endOfMonth, subDays } from "date-fns";

export function resolveDatesFromData(data: string): { dataIni: string; dataFim: string } {
	const hoje = new Date();

	switch (data) {
		case "hoje":
			return {
				dataIni: format(hoje, "yyyy-MM-dd"),
				dataFim: format(hoje, "yyyy-MM-dd"),
			};
		case "anterior":
			const mesAnterior = subDays(startOfMonth(hoje), 1);
			return {
				dataIni: format(startOfMonth(mesAnterior), "yyyy-MM-dd"),
				dataFim: format(endOfMonth(mesAnterior), "yyyy-MM-dd"),
			};
		case "7":
			return {
				dataIni: format(subDays(hoje, 7), "yyyy-MM-dd"),
				dataFim: format(hoje, "yyyy-MM-dd"),
			};
		case "15":
			return {
				dataIni: format(subDays(hoje, 15), "yyyy-MM-dd"),
				dataFim: format(hoje, "yyyy-MM-dd"),
			};
		case "30":
			return {
				dataIni: format(subDays(hoje, 30), "yyyy-MM-dd"),
				dataFim: format(hoje, "yyyy-MM-dd"),
			};
		case "60":
			return {
				dataIni: format(subDays(hoje, 60), "yyyy-MM-dd"),
				dataFim: format(hoje, "yyyy-MM-dd"),
			};
		case "90":
			return {
				dataIni: format(subDays(hoje, 90), "yyyy-MM-dd"),
				dataFim: format(hoje, "yyyy-MM-dd"),
			};
		case "ano":
			return {
				dataIni: format(startOfMonth(new Date(hoje.getFullYear(), 0, 1)), "yyyy-MM-dd"),
				dataFim: format(endOfMonth(new Date(hoje.getFullYear(), 11, 31)), "yyyy-MM-dd"),
			};
		case "mes":
			return {
				dataIni: format(startOfMonth(hoje), "yyyy-MM-dd"),
				dataFim: format(endOfMonth(hoje), "yyyy-MM-dd"),
			};
		default:
			return { dataIni: "", dataFim: "" };
	}
}
